/* global Alpine */
document.addEventListener('alpine:init', () => {
  Alpine.data('thankYouPage', () => ({
    title: '',
    email: '',
    link: '#',

    getUrlParam(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name) || '';
    },

    async init() {
      const { addCapterraScript } = await import('./analytics');
      addCapterraScript();
      this.title = this.getUrlParam('title') || '';
      this.email = this.getUrlParam('email') || 'email is not provided';
      this.link = this.getUrlParam('link') || '';
    }
  }));
});